import { colors } from "../colors";

export function CloseIcon({
  width = 24,
  height = 25,
  strokeWidth = 5,
  color = colors.bodyText,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1728_27722)">
        <path
          d="M19.41 17.9999L27.7 9.70994C27.8638 9.51864 27.9494 9.27256 27.9397 9.02089C27.93 8.76921 27.8256 8.53047 27.6475 8.35238C27.4694 8.17428 27.2307 8.06995 26.979 8.06023C26.7274 8.05051 26.4813 8.13612 26.29 8.29994L18 16.5899L9.70997 8.28994C9.52167 8.10164 9.26627 7.99585 8.99997 7.99585C8.73367 7.99585 8.47828 8.10164 8.28997 8.28994C8.10167 8.47825 7.99588 8.73364 7.99588 8.99994C7.99588 9.26624 8.10167 9.52164 8.28997 9.70994L16.59 17.9999L8.28997 26.2899C8.18529 26.3796 8.10027 26.4899 8.04025 26.614C7.98022 26.738 7.94649 26.8732 7.94117 27.0109C7.93586 27.1486 7.95906 27.2859 8.00934 27.4143C8.05961 27.5426 8.13587 27.6591 8.23332 27.7566C8.33078 27.854 8.44732 27.9303 8.57565 27.9806C8.70398 28.0309 8.84131 28.0541 8.97903 28.0487C9.11675 28.0434 9.25188 28.0097 9.37594 27.9497C9.50001 27.8896 9.61033 27.8046 9.69997 27.6999L18 19.4099L26.29 27.6999C26.4813 27.8638 26.7274 27.9494 26.979 27.9397C27.2307 27.9299 27.4694 27.8256 27.6475 27.6475C27.8256 27.4694 27.93 27.2307 27.9397 26.979C27.9494 26.7273 27.8638 26.4812 27.7 26.2899L19.41 17.9999Z"
          fill={color}
          stroke={color}
          strokeWidth={strokeWidth}
        />
      </g>
      <defs>
        <clipPath id="clip0_1728_27722">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PlusIcon({ width = 19, height = 19, color = colors.mainBg }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0.75C9.79008 0.75 10.0683 0.865234 10.2734 1.07035C10.4785 1.27547 10.5938 1.55367 10.5938 1.84375V8.40625H17.1562C17.4463 8.40625 17.7245 8.52148 17.9296 8.7266C18.1348 8.93172 18.25 9.20992 18.25 9.5C18.25 9.79008 18.1348 10.0683 17.9296 10.2734C17.7245 10.4785 17.4463 10.5938 17.1562 10.5938H10.5938V17.1562C10.5938 17.4463 10.4785 17.7245 10.2734 17.9296C10.0683 18.1348 9.79008 18.25 9.5 18.25C9.20992 18.25 8.93172 18.1348 8.7266 17.9296C8.52148 17.7245 8.40625 17.4463 8.40625 17.1562V10.5938H1.84375C1.55367 10.5938 1.27547 10.4785 1.07035 10.2734C0.865234 10.0683 0.75 9.79008 0.75 9.5C0.75 9.20992 0.865234 8.93172 1.07035 8.7266C1.27547 8.52148 1.55367 8.40625 1.84375 8.40625H8.40625V1.84375C8.40625 1.55367 8.52148 1.27547 8.7266 1.07035C8.93172 0.865234 9.20992 0.75 9.5 0.75Z"
        fill={color}
      />
    </svg>
  );
}

export function MinusIcon({ width = 19, height = 3, color = colors.mainBg }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2778 0.527771H1.72222C1.46437 0.527771 1.21708 0.630201 1.03476 0.812528C0.85243 0.994855 0.75 1.24214 0.75 1.49999C0.75 1.75784 0.85243 2.00513 1.03476 2.18746C1.21708 2.36979 1.46437 2.47222 1.72222 2.47222H17.2778C17.5356 2.47222 17.7829 2.36979 17.9652 2.18746C18.1476 2.00513 18.25 1.75784 18.25 1.49999C18.25 1.24214 18.1476 0.994855 17.9652 0.812528C17.7829 0.630201 17.5356 0.527771 17.2778 0.527771Z"
        fill={color}
      />
    </svg>
  );
}

export function ArrowUpIcon({ width = 24, height = 24, color = colors.blue }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <path
        d="m12 6.586-8.707 8.707 1.414 1.414L12 9.414l7.293 7.293 1.414-1.414L12 6.586z"
        fill={color}
      />
    </svg>
  );
}

export function ArrowDownIcon({ width = 10, height = 5, color = colors.blue }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <path d="M5.016 0 0 .003 2.506 2.5 5.016 5l2.509-2.5L10.033.003 5.016 0z" />
    </svg>
  );
}

export function CheckBoxIcon({
  width = 28,
  height = 28,
  color = colors.textBlue,
  // strokeWidth = 1,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`2 2 ${width + 9} ${height + 9}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 7.875C3.5 6.71468 3.96094 5.60188 4.78141 4.78141C5.60188 3.96094 6.71468 3.5 7.875 3.5H20.125C21.2853 3.5 22.3981 3.96094 23.2186 4.78141C24.0391 5.60188 24.5 6.71468 24.5 7.875V20.125C24.5 21.2853 24.0391 22.3981 23.2186 23.2186C22.3981 24.0391 21.2853 24.5 20.125 24.5H7.875C6.71468 24.5 5.60188 24.0391 4.78141 23.2186C3.96094 22.3981 3.5 21.2853 3.5 20.125V7.875ZM7.875 5.25C7.17881 5.25 6.51113 5.52656 6.01884 6.01884C5.52656 6.51113 5.25 7.17881 5.25 7.875V20.125C5.25 20.8212 5.52656 21.4889 6.01884 21.9812C6.51113 22.4734 7.17881 22.75 7.875 22.75H20.125C20.8212 22.75 21.4889 22.4734 21.9812 21.9812C22.4734 21.4889 22.75 20.8212 22.75 20.125V7.875C22.75 7.17881 22.4734 6.51113 21.9812 6.01884C21.4889 5.52656 20.8212 5.25 20.125 5.25H7.875Z"
        fill={color}
        // strokeWidth={strokeWidth}
        // stroke={color}
      />
    </svg>
  );
}

export function CheckBoxActiveIcon({
  width = 28,
  height = 28,
  color = colors.textBlue,
  // strokeWidth = 1,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`2 2 ${width + 9} ${height + 9}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.54199 3.5C7.38167 3.5 6.26887 3.96094 5.4484 4.78141C4.62793 5.60188 4.16699 6.71468 4.16699 7.875V20.125C4.16699 21.2853 4.62793 22.3981 5.4484 23.2186C6.26887 24.0391 7.38167 24.5 8.54199 24.5H20.792C21.9523 24.5 23.0651 24.0391 23.8856 23.2186C24.7061 22.3981 25.167 21.2853 25.167 20.125V7.875C25.167 6.71468 24.7061 5.60188 23.8856 4.78141C23.0651 3.96094 21.9523 3.5 20.792 3.5H8.54199ZM5.91699 7.875C5.91699 7.17881 6.19355 6.51113 6.68584 6.01884C7.17812 5.52656 7.8458 5.25 8.54199 5.25H20.792C21.4882 5.25 22.1559 5.52656 22.6481 6.01884C23.1404 6.51113 23.417 7.17881 23.417 7.875V20.125C23.417 20.8212 23.1404 21.4889 22.6481 21.9812C22.1559 22.4734 21.4882 22.75 20.792 22.75H8.54199C7.8458 22.75 7.17812 22.4734 6.68584 21.9812C6.19355 21.4889 5.91699 20.8212 5.91699 20.125V7.875ZM19.6615 11.9945C19.8258 11.8302 19.9181 11.6074 19.9181 11.375C19.9181 11.1426 19.8258 10.9198 19.6615 10.7555C19.4972 10.5912 19.2744 10.4989 19.042 10.4989C18.8096 10.4989 18.5868 10.5912 18.4225 10.7555L12.917 16.2628L10.9115 14.2555C10.7472 14.0912 10.5243 13.9989 10.292 13.9989C10.0596 13.9989 9.83679 14.0912 9.67249 14.2555C9.50819 14.4198 9.41589 14.6426 9.41589 14.875C9.41589 15.1074 9.50819 15.3302 9.67249 15.4945L12.2975 18.1195C12.3788 18.201 12.4753 18.2656 12.5816 18.3097C12.6879 18.3539 12.8019 18.3766 12.917 18.3766C13.0321 18.3766 13.146 18.3539 13.2524 18.3097C13.3587 18.2656 13.4552 18.201 13.5365 18.1195L19.6615 11.9945Z"
        fill={color}
        // strokeWidth={strokeWidth}
        // stroke={color}
      />
    </svg>
  );
}

export function CalendarIcon({
  width = 28,
  height = 28,
  color = colors.blue,
  // strokeWidth = 1,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      viewBox={`0 0 ${width + 8} ${height + 6}`}
    >
      <g>
        <g>
          <path
            fill={color}
            d="M7.685,24.819H8.28v-2.131h3.688v2.131h0.596v-2.131h3.862v2.131h0.597v-2.131h4.109v2.131h0.595    v-2.131h3.417v-0.594h-3.417v-3.861h3.417v-0.596h-3.417v-3.519h3.417v-0.594h-3.417v-2.377h-0.595v2.377h-4.109v-2.377h-0.597    v2.377h-3.862v-2.377h-0.596v2.377H8.279v-2.377H7.685v2.377H3.747v0.594h3.938v3.519H3.747v0.596h3.938v3.861H3.747v0.594h3.938    V24.819z M12.563,22.094v-3.861h3.862v3.861H12.563z M21.132,22.094h-4.109v-3.861h4.109V22.094z M21.132,14.118v3.519h-4.109    v-3.519C17.023,14.119,21.132,14.119,21.132,14.118z M16.426,14.118v3.519h-3.862v-3.519    C12.564,14.119,16.426,14.119,16.426,14.118z M8.279,14.118h3.688v3.519H8.279V14.118z M8.279,18.233h3.688v3.861H8.279V18.233z"
          />
          <path
            fill={color}
            d="M29.207,2.504l-4.129,0.004L24.475,2.51v2.448c0,0.653-0.534,1.187-1.188,1.187h-1.388    c-0.656,0-1.188-0.533-1.188-1.187V2.514l-1.583,0.002v2.442c0,0.653-0.535,1.187-1.191,1.187h-1.388    c-0.655,0-1.188-0.533-1.188-1.187V2.517l-1.682,0.004v2.438c0,0.653-0.534,1.187-1.189,1.187h-1.389    c-0.653,0-1.188-0.533-1.188-1.187V2.525H8.181v2.434c0,0.653-0.533,1.187-1.188,1.187H5.605c-0.656,0-1.189-0.533-1.189-1.187    V2.53L0,2.534v26.153h2.09h25.06l2.087-0.006L29.207,2.504z M27.15,26.606H2.09V9.897h25.06V26.606z"
          />
          <path
            fill={color}
            d="M5.605,5.303h1.388c0.163,0,0.296-0.133,0.296-0.297v-4.16c0-0.165-0.133-0.297-0.296-0.297H5.605    c-0.165,0-0.298,0.132-0.298,0.297v4.16C5.307,5.17,5.44,5.303,5.605,5.303z"
          />
          <path
            fill={color}
            d="M11.101,5.303h1.389c0.164,0,0.297-0.133,0.297-0.297v-4.16c-0.001-0.165-0.134-0.297-0.298-0.297    H11.1c-0.163,0-0.296,0.132-0.296,0.297v4.16C10.805,5.17,10.938,5.303,11.101,5.303z"
          />
          <path
            fill={color}
            d="M16.549,5.303h1.388c0.166,0,0.299-0.133,0.299-0.297v-4.16c-0.001-0.165-0.133-0.297-0.299-0.297    h-1.388c-0.164,0-0.297,0.132-0.297,0.297v4.16C16.252,5.17,16.385,5.303,16.549,5.303z"
          />
          <path
            fill={color}
            d="M21.899,5.303h1.388c0.164,0,0.296-0.133,0.296-0.297v-4.16c0-0.165-0.132-0.297-0.296-0.297    h-1.388c-0.164,0-0.297,0.132-0.297,0.297v4.16C21.603,5.17,21.735,5.303,21.899,5.303z"
          />
        </g>
      </g>
    </svg>
  );
}

export function DownloadIcon({
  width = 28,
  height = 28,
  color = colors.mainBg,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      viewBox="0 -3 32 32"
    >
      <path d="M 6 3 L 6 29 L 26 29 L 26 9.5996094 L 25.699219 9.3007812 L 19.699219 3.3007812 L 19.400391 3 L 6 3 z M 8 5 L 18 5 L 18 11 L 24 11 L 24 27 L 8 27 L 8 5 z M 20 6.4003906 L 22.599609 9 L 20 9 L 20 6.4003906 z M 15 13 L 15 18 L 12 18 L 16 22 L 20 18 L 17 18 L 17 13 L 15 13 z M 12 23 L 12 25 L 20 25 L 20 23 L 12 23 z" />
    </svg>
  );
}

export function PrintIcon({ width = 28, height = 40, color = colors.mainBg }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="2 -10 20 40"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3C5 2.44772 5.44772 2 6 2H15C15.2652 2 15.5196 2.10536 15.7071 2.29289L18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6V8H20C21.6569 8 23 9.34315 23 11V16C23 17.1046 22.1046 18 21 18H19V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V18H3C1.89543 18 1 17.1046 1 16V11C1 9.34315 2.34315 8 4 8H5V3ZM4 10C3.44772 10 3 10.4477 3 11V16H5V14C5 13.4477 5.44772 13 6 13H18C18.5523 13 19 13.4477 19 14V16H21V11C21 10.4477 20.5523 10 20 10H4ZM17 8H7V4H14.5858L17 6.41421V8ZM7 15V20H17V15H7Z"
        fill={color}
      />
    </svg>
  );
}

export function DragReorderIcon({
  width = 24,
  height = 24,
  color = colors.mainBg,
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" stroke="none" fill={color} opacity="0" />

      <g transform="matrix(0.77 0 0 0.77 12 12)">
        <path
          fill={color}
          transform=" translate(-15, -15)"
          d="M 15 2 L 11 6 L 19 6 L 15 2 z M 5 9 C 4.639364083422431 8.994899710454515 4.303918635428393 9.184375296169332 4.122112278513483 9.495872849714331 C 3.9403059215985725 9.80737040325933 3.940305921598573 10.192629596740671 4.122112278513484 10.50412715028567 C 4.303918635428394 10.815624703830668 4.639364083422431 11.005100289545485 5.000000000000001 11 L 25 11 C 25.360635916577568 11.005100289545485 25.696081364571608 10.815624703830668 25.877887721486516 10.504127150285669 C 26.059694078401428 10.192629596740671 26.059694078401428 9.80737040325933 25.877887721486516 9.495872849714331 C 25.696081364571608 9.184375296169332 25.360635916577568 8.994899710454515 25 9 L 5 9 z M 5 14 C 4.639364083422431 13.994899710454515 4.303918635428393 14.184375296169332 4.122112278513483 14.495872849714331 C 3.9403059215985725 14.80737040325933 3.940305921598573 15.192629596740671 4.122112278513484 15.50412715028567 C 4.303918635428394 15.815624703830668 4.639364083422431 16.005100289545485 5.000000000000001 16 L 25 16 C 25.360635916577568 16.005100289545485 25.696081364571608 15.815624703830668 25.877887721486516 15.504127150285669 C 26.059694078401428 15.192629596740671 26.059694078401428 14.80737040325933 25.877887721486516 14.495872849714331 C 25.696081364571608 14.184375296169332 25.360635916577568 13.994899710454515 25 14 L 5 14 z M 5 19 C 4.639364083422431 18.994899710454515 4.303918635428393 19.184375296169332 4.122112278513483 19.49587284971433 C 3.9403059215985725 19.80737040325933 3.940305921598573 20.192629596740673 4.122112278513484 20.50412715028567 C 4.303918635428394 20.815624703830668 4.639364083422431 21.005100289545485 5.000000000000001 21 L 25 21 C 25.360635916577568 21.005100289545485 25.696081364571608 20.815624703830668 25.877887721486516 20.50412715028567 C 26.059694078401428 20.19262959674067 26.059694078401428 19.80737040325933 25.877887721486516 19.49587284971433 C 25.696081364571608 19.184375296169332 25.360635916577568 18.994899710454515 25 19 L 5 19 z M 11 24 L 15 28 L 19 24 L 11 24 z"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

export function OptionsIcon({
  width = 20,
  height = 24,
  color = colors.mainBg,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <path d="M12.15 28.012v-0.85c0.019-0.069 0.050-0.131 0.063-0.2 0.275-1.788 1.762-3.2 3.506-3.319 1.95-0.137 3.6 0.975 4.137 2.787 0.069 0.238 0.119 0.488 0.181 0.731v0.85c-0.019 0.056-0.050 0.106-0.056 0.169-0.269 1.65-1.456 2.906-3.081 3.262-0.125 0.025-0.25 0.063-0.375 0.094h-0.85c-0.056-0.019-0.113-0.050-0.169-0.056-1.625-0.262-2.862-1.419-3.237-3.025-0.037-0.156-0.081-0.3-0.119-0.444zM20.038 3.988l-0 0.85c-0.019 0.069-0.050 0.131-0.056 0.2-0.281 1.8-1.775 3.206-3.538 3.319-1.944 0.125-3.588-1-4.119-2.819-0.069-0.231-0.119-0.469-0.175-0.7v-0.85c0.019-0.056 0.050-0.106 0.063-0.162 0.3-1.625 1.244-2.688 2.819-3.194 0.206-0.069 0.425-0.106 0.637-0.162h0.85c0.056 0.019 0.113 0.050 0.169 0.056 1.631 0.269 2.863 1.419 3.238 3.025 0.038 0.15 0.075 0.294 0.113 0.437zM20.037 15.575v0.85c-0.019 0.069-0.050 0.131-0.063 0.2-0.281 1.794-1.831 3.238-3.581 3.313-1.969 0.087-3.637-1.1-4.106-2.931-0.050-0.194-0.094-0.387-0.137-0.581v-0.85c0.019-0.069 0.050-0.131 0.063-0.2 0.275-1.794 1.831-3.238 3.581-3.319 1.969-0.094 3.637 1.1 4.106 2.931 0.050 0.2 0.094 0.394 0.137 0.588z" />
    </svg>
  );
}
